import { get, set, cloneDeep, includes } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const ensurePapaParseOrder = ({
  parseResult,
  orderedHeaders = [],
  keepRest = true,
  showMissingColumns = false,
}) => {
  const copy = cloneDeep(parseResult);
  const inputHeaders = get(copy, 'meta.fields', []);
  const outputHeaders = [];

  orderedHeaders.forEach((name) => {
    if (includes(inputHeaders, name) || showMissingColumns) {
      outputHeaders.push(name);
    }
  });

  if (keepRest) {
    inputHeaders.forEach((name) => {
      if (!includes(orderedHeaders, name)) {
        outputHeaders.push(name);
      }
    });
  }

  set(copy, 'meta.fields', outputHeaders);
  return copy;
};
